<template>
    <div>
        <b-row class="mb-3">
            <b-col cols="12">
                <app-title text="Protocolos de seguridad"></app-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <router-view></router-view>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
